// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactMe {
  padding-top: 300px;
  padding-bottom: 300px; }

input {
  outline: none;
  border: none; }

input[type='number'] {
  appearance: none;
  -webkit-appearance: none; }

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none; }

textarea {
  outline: none;
  border: none; }

textarea:focus,
input:focus {
  border-color: transparent !important; }

input:focus::-webkit-input-placeholder {
  color: transparent; }

input:focus:-moz-placeholder {
  color: transparent; }

input:focus::-moz-placeholder {
  color: transparent; }

input:focus:-ms-input-placeholder {
  color: transparent; }

textarea:focus::-webkit-input-placeholder {
  color: transparent; }

textarea:focus:-moz-placeholder {
  color: transparent; }

textarea:focus::-moz-placeholder {
  color: transparent; }

textarea:focus:-ms-input-placeholder {
  color: transparent; }

input::-webkit-input-placeholder {
  color: #cccccc; }

input:-moz-placeholder {
  color: #cccccc; }

input::-moz-placeholder {
  color: #cccccc; }

input:-ms-input-placeholder {
  color: #cccccc; }

textarea::-webkit-input-placeholder {
  color: #cccccc; }

textarea:-moz-placeholder {
  color: #cccccc; }

textarea::-moz-placeholder {
  color: #cccccc; }

textarea:-ms-input-placeholder {
  color: #cccccc; }

button {
  outline: none !important;
  border: none;
  background: transparent; }

button:hover {
  cursor: pointer; }

.container-contact {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  background: transparent;
  position: relative;
  z-index: 1; }

.background {
  position: absolute;
  z-index: -2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0; }

#overlay {
  opacity: 0.7;
  background-color: black;
  z-index: 5 !important; }

.wrap-contact {
  width: 640px;
  min-height: 100vh;
  background: #fff;
  border-radius: 2px;
  padding: 82px 55px 33px 55px;
  position: relative; }

.show-wrap-contact {
  visibility: visible;
  opacity: 1; }

.contact-form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 68px; }

.contact-form-title {
  display: block;
  width: 100%;
  font-family: Poppins-Bold;
  font-size: 39px;
  color: #333333;
  line-height: 1.2;
  text-align: left;
  padding-bottom: 64px; }

.wrap-input {
  width: 100%;
  position: relative;
  border-bottom: 2px solid #dbdbdb;
  margin-bottom: 45px; }

.label-input {
  font-family: Poppins-SemiBold;
  font-size: 18px;
  color: #999999;
  line-height: 1.2;
  padding-left: 2px; }

.input {
  display: block;
  width: 100%;
  background: transparent;
  font-family: Poppins-Regular;
  font-size: 22px;
  color: #555555;
  line-height: 1.2;
  padding: 0 2px; }

.focus-input {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none; }

.focus-input::before {
  content: '';
  display: block;
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  transition: all 0.4s;
  background: #df254e;
  background: linear-gradient(45deg, #429f98, #116466); }

input.input {
  height: 50px; }

textarea.input {
  min-height: 140px;
  padding-top: 13px;
  padding-bottom: 13px; }

.input:focus + .focus-input::before {
  width: 100%; }

.has-val.input + .focus-input::before {
  width: 100%; }

.container-contact-form-btn {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center; }

.wrap-contact-form-btn {
  display: block;
  position: relative;
  z-index: 1;
  border-radius: 25px;
  overflow: hidden; }

.contact-form-bgbtn {
  position: absolute;
  z-index: -1;
  width: 300%;
  height: 100%;
  background: #429f98;
  background: linear-gradient(-135deg, #429f98, #116466, #429f98, #116466);
  top: 0;
  left: -100%;
  transition: all 0.4s; }

.contact-form-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  min-width: 244px;
  height: 50px;
  font-family: Poppins-Medium;
  font-size: 16px;
  color: #fff;
  line-height: 1.2; }

.wrap-contact-form-btn:hover .contact-form-bgbtn {
  left: 0; }

@media (max-width: 576px) {
  .wrap-contact {
    padding: 82px 15px 33px 15px; } }

.validate-input {
  position: relative; }

.alert-validate::before {
  content: attr(data-validate);
  position: absolute;
  max-width: 70%;
  background-color: #fff;
  border: 1px solid #c80000;
  border-radius: 2px;
  padding: 4px 30px 4px 10px;
  bottom: calc((100% - 25px) / 2);
  transform: translateY(50%);
  right: 2px;
  pointer-events: none;
  font-family: Poppins-Medium;
  color: #c80000;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.4s; }

.alert-validate::after {
  content: '\\f06a';
  font-family: FontAwesome;
  display: block;
  position: absolute;
  color: #c80000;
  font-size: 18px;
  bottom: calc((100% - 25px) / 2);
  transform: translateY(50%);
  right: 8px; }

.alert-validate:hover:before {
  visibility: visible;
  opacity: 1; }

@media (max-width: 992px) {
  .alert-validate::before {
    visibility: visible;
    opacity: 1; } }

.true-validate::after {
  content: '\\f26b';
  font-family: Material-Design-Iconic-Font;
  font-size: 22px;
  color: #00ad5f;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: calc((100% - 25px) / 2);
  transform: translateY(50%);
  right: 5px; }

.contact-icons {
  font-family: Poppins-Medium;
  font-size: 50px;
  color: #000;
  position: absolute;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0px; }
  .contact-icons h2 {
    color: black;
    margin: auto; }

.contact-icons i {
  font-size: 20px;
  margin-right: 10px;
  z-index: 10; }

#facebook:hover {
  color: #116466; }

#twitter:hover {
  color: #116466; }

#linkedin:hover {
  color: #116466; }

#github:hover {
  color: #116466; }

#email:hover {
  color: #116466; }

@media (max-width: 1200px) {
  .wrap-contact {
    width: 440px; }
  .background {
    width: calc(100% - 440px); } }

@media (max-width: 425px) {
  .contact-icons {
    left: 61%;
    margin-top: 150px; } }

.nohighlight {
  text-decoration: none;
  color: black; }
`, "",{"version":3,"sources":["webpack://./src/store/components/contactMe/index.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,qBAAqB,EAAA;;AAGzB;EACI,aAAa;EACb,YAAY,EAAA;;AAGhB;EAEI,gBAAgB;EAChB,wBAAwB,EAAA;;AAG5B;;EAEI,wBAAwB,EAAA;;AAG5B;EACI,aAAa;EACb,YAAY,EAAA;;AAGhB;;EAEI,oCAAoC,EAAA;;AAGxC;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAGtB;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAGtB;EACI,cAAc,EAAA;;AAElB;EACI,cAAc,EAAA;;AAElB;EACI,cAAc,EAAA;;AAElB;EACI,cAAc,EAAA;;AAGlB;EACI,cAAc,EAAA;;AAElB;EACI,cAAc,EAAA;;AAElB;EACI,cAAc,EAAA;;AAElB;EACI,cAAc,EAAA;;AAGlB;EACI,wBAAwB;EACxB,YAAY;EACZ,uBAAuB,EAAA;;AAG3B;EACI,eAAe,EAAA;;AAGnB;EACI,WAAW;EAMX,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU,EAAA;;AAGd;EACI,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO,EAAA;;AAGX;EACI,YAAY;EACZ,uBAAuB;EACvB,qBAAqB,EAAA;;AAEzB;EACI,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB,EAAA;;AAGtB;EACI,mBAAmB;EACnB,UAAU,EAAA;;AAGd;EACI,WAAW;EAKX,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB,EAAA;;AAGxB;EACI,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB,EAAA;;AAGxB;EACI,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB,EAAA;;AAGvB;EACI,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB,EAAA;;AAGrB;EACI,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc,EAAA;;AAGlB;EACI,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB,EAAA;;AAGxB;EACI,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EAKX,oBAAoB;EAEpB,mBAAmB;EAInB,oDAAoD,EAAA;;AAGxD;EACI,YAAY,EAAA;;AAGhB;EACI,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB,EAAA;;AAGxB;EACI,WAAW,EAAA;;AAGf;EACI,WAAW,EAAA;;AAGf;EACI,WAAW;EAKX,aAAa;EACb,eAAe;EACf,uBAAuB,EAAA;;AAG3B;EACI,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB,EAAA;;AAGpB;EACI,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EAgBnB,wEAAwE;EACxE,MAAM;EACN,WAAW;EAKX,oBAAoB,EAAA;;AAGxB;EAKI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EAEZ,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,gBAAgB,EAAA;;AAGpB;EACI,OAAO,EAAA;;AAGX;EACI;IACI,4BAA4B,EAAA,EAC/B;;AAGL;EACI,kBAAkB,EAAA;;AAGtB;EACI,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAK/B,0BAA0B;EAC1B,UAAU;EACV,oBAAoB;EAEpB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAEhB,kBAAkB;EAClB,UAAU;EAKV,wBAAwB,EAAA;;AAG5B;EACI,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,+BAA+B;EAK/B,0BAA0B;EAC1B,UAAU,EAAA;;AAGd;EACI,mBAAmB;EACnB,UAAU,EAAA;;AAGd;EACI;IACI,mBAAmB;IACnB,UAAU,EAAA,EACb;;AAGL;EACI,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,cAAc;EAKd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAK/B,0BAA0B;EAC1B,UAAU,EAAA;;AAGd;EACI,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EAKX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAWnB,QAAQ;EACR,SAAS;EAKT,gCAAgC;EAChC,eAAe,EAAA;EA9BnB;IAcQ,YAAY;IACZ,YAAY,EAAA;;AAkBpB;EACI,eAAe;EACf,kBAAkB;EAClB,WAAW,EAAA;;AAGf;EACI,cAAc,EAAA;;AAElB;EACI,cAAc,EAAA;;AAGlB;EACI,cAAc,EAAA;;AAGlB;EACI,cAAc,EAAA;;AAGlB;EACI,cAAc,EAAA;;AAGlB;EACI;IACI,YAAY,EAAA;EAGhB;IACI,yBAAyB,EAAA,EAC5B;;AAGL;EACI;IACI,SAAS;IACT,iBAAiB,EAAA,EACpB;;AAsBL;EACI,qBAAqB;EACrB,YAAY,EAAA","sourcesContent":[".contactMe {\n    padding-top: 300px;\n    padding-bottom: 300px;\n}\n\ninput {\n    outline: none;\n    border: none;\n}\n\ninput[type='number'] {\n    -moz-appearance: textfield;\n    appearance: none;\n    -webkit-appearance: none;\n}\n\ninput[type='number']::-webkit-outer-spin-button,\ninput[type='number']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n\ntextarea {\n    outline: none;\n    border: none;\n}\n\ntextarea:focus,\ninput:focus {\n    border-color: transparent !important;\n}\n\ninput:focus::-webkit-input-placeholder {\n    color: transparent;\n}\ninput:focus:-moz-placeholder {\n    color: transparent;\n}\ninput:focus::-moz-placeholder {\n    color: transparent;\n}\ninput:focus:-ms-input-placeholder {\n    color: transparent;\n}\n\ntextarea:focus::-webkit-input-placeholder {\n    color: transparent;\n}\ntextarea:focus:-moz-placeholder {\n    color: transparent;\n}\ntextarea:focus::-moz-placeholder {\n    color: transparent;\n}\ntextarea:focus:-ms-input-placeholder {\n    color: transparent;\n}\n\ninput::-webkit-input-placeholder {\n    color: #cccccc;\n}\ninput:-moz-placeholder {\n    color: #cccccc;\n}\ninput::-moz-placeholder {\n    color: #cccccc;\n}\ninput:-ms-input-placeholder {\n    color: #cccccc;\n}\n\ntextarea::-webkit-input-placeholder {\n    color: #cccccc;\n}\ntextarea:-moz-placeholder {\n    color: #cccccc;\n}\ntextarea::-moz-placeholder {\n    color: #cccccc;\n}\ntextarea:-ms-input-placeholder {\n    color: #cccccc;\n}\n\nbutton {\n    outline: none !important;\n    border: none;\n    background: transparent;\n}\n\nbutton:hover {\n    cursor: pointer;\n}\n\n.container-contact {\n    width: 100%;\n    // min-height: 100vh;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    align-items: center;\n    background: transparent;\n    position: relative;\n    z-index: 1;\n}\n\n.background {\n    position: absolute;\n    z-index: -2;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n\n#overlay {\n    opacity: 0.7;\n    background-color: black;\n    z-index: 5 !important;\n}\n.wrap-contact {\n    width: 640px;\n    min-height: 100vh;\n    background: #fff;\n    border-radius: 2px;\n    padding: 82px 55px 33px 55px;\n    position: relative;\n}\n\n.show-wrap-contact {\n    visibility: visible;\n    opacity: 1;\n}\n\n.contact-form {\n    width: 100%;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding-bottom: 68px;\n}\n\n.contact-form-title {\n    display: block;\n    width: 100%;\n    font-family: Poppins-Bold;\n    font-size: 39px;\n    color: #333333;\n    line-height: 1.2;\n    text-align: left;\n    padding-bottom: 64px;\n}\n\n.wrap-input {\n    width: 100%;\n    position: relative;\n    border-bottom: 2px solid #dbdbdb;\n    margin-bottom: 45px;\n}\n\n.label-input {\n    font-family: Poppins-SemiBold;\n    font-size: 18px;\n    color: #999999;\n    line-height: 1.2;\n    padding-left: 2px;\n}\n\n.input {\n    display: block;\n    width: 100%;\n    background: transparent;\n    font-family: Poppins-Regular;\n    font-size: 22px;\n    color: #555555;\n    line-height: 1.2;\n    padding: 0 2px;\n}\n\n.focus-input {\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n}\n\n.focus-input::before {\n    content: '';\n    display: block;\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    width: 0;\n    height: 2px;\n\n    -webkit-transition: all 0.4s;\n    -o-transition: all 0.4s;\n    -moz-transition: all 0.4s;\n    transition: all 0.4s;\n\n    background: #df254e;\n    background: -webkit-linear-gradient(45deg, #429f98, #116466);\n    background: -o-linear-gradient(45deg, #429f98, #116466);\n    background: -moz-linear-gradient(45deg, #429f98, #116466);\n    background: linear-gradient(45deg, #429f98, #116466);\n}\n\ninput.input {\n    height: 50px;\n}\n\ntextarea.input {\n    min-height: 140px;\n    padding-top: 13px;\n    padding-bottom: 13px;\n}\n\n.input:focus + .focus-input::before {\n    width: 100%;\n}\n\n.has-val.input + .focus-input::before {\n    width: 100%;\n}\n\n.container-contact-form-btn {\n    width: 100%;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.wrap-contact-form-btn {\n    display: block;\n    position: relative;\n    z-index: 1;\n    border-radius: 25px;\n    overflow: hidden;\n}\n\n.contact-form-bgbtn {\n    position: absolute;\n    z-index: -1;\n    width: 300%;\n    height: 100%;\n    background: #429f98;\n    background: -webkit-linear-gradient(\n        -135deg,\n        #429f98,\n        #116466,\n        #429f98,\n        #116466\n    );\n    background: -o-linear-gradient(-135deg, #429f98, #116466, #429f98, #116466);\n    background: -moz-linear-gradient(\n        -135deg,\n        #429f98,\n        #116466,\n        #429f98,\n        #116466\n    );\n    background: linear-gradient(-135deg, #429f98, #116466, #429f98, #116466);\n    top: 0;\n    left: -100%;\n\n    -webkit-transition: all 0.4s;\n    -o-transition: all 0.4s;\n    -moz-transition: all 0.4s;\n    transition: all 0.4s;\n}\n\n.contact-form-btn {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 20px;\n    min-width: 244px;\n    height: 50px;\n\n    font-family: Poppins-Medium;\n    font-size: 16px;\n    color: #fff;\n    line-height: 1.2;\n}\n\n.wrap-contact-form-btn:hover .contact-form-bgbtn {\n    left: 0;\n}\n\n@media (max-width: 576px) {\n    .wrap-contact {\n        padding: 82px 15px 33px 15px;\n    }\n}\n\n.validate-input {\n    position: relative;\n}\n\n.alert-validate::before {\n    content: attr(data-validate);\n    position: absolute;\n    max-width: 70%;\n    background-color: #fff;\n    border: 1px solid #c80000;\n    border-radius: 2px;\n    padding: 4px 30px 4px 10px;\n    bottom: calc((100% - 25px) / 2);\n    -webkit-transform: translateY(50%);\n    -moz-transform: translateY(50%);\n    -ms-transform: translateY(50%);\n    -o-transform: translateY(50%);\n    transform: translateY(50%);\n    right: 2px;\n    pointer-events: none;\n\n    font-family: Poppins-Medium;\n    color: #c80000;\n    font-size: 14px;\n    line-height: 1.4;\n    text-align: left;\n\n    visibility: hidden;\n    opacity: 0;\n\n    -webkit-transition: opacity 0.4s;\n    -o-transition: opacity 0.4s;\n    -moz-transition: opacity 0.4s;\n    transition: opacity 0.4s;\n}\n\n.alert-validate::after {\n    content: '\\f06a';\n    font-family: FontAwesome;\n    display: block;\n    position: absolute;\n    color: #c80000;\n    font-size: 18px;\n    bottom: calc((100% - 25px) / 2);\n    -webkit-transform: translateY(50%);\n    -moz-transform: translateY(50%);\n    -ms-transform: translateY(50%);\n    -o-transform: translateY(50%);\n    transform: translateY(50%);\n    right: 8px;\n}\n\n.alert-validate:hover:before {\n    visibility: visible;\n    opacity: 1;\n}\n\n@media (max-width: 992px) {\n    .alert-validate::before {\n        visibility: visible;\n        opacity: 1;\n    }\n}\n\n.true-validate::after {\n    content: '\\f26b';\n    font-family: Material-Design-Iconic-Font;\n    font-size: 22px;\n    color: #00ad5f;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    bottom: calc((100% - 25px) / 2);\n    -webkit-transform: translateY(50%);\n    -moz-transform: translateY(50%);\n    -ms-transform: translateY(50%);\n    -o-transform: translateY(50%);\n    transform: translateY(50%);\n    right: 5px;\n}\n\n.contact-icons {\n    font-family: Poppins-Medium;\n    font-size: 50px;\n    color: #000;\n    position: absolute;\n    z-index: 10;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    h2 {\n        color: black;\n        margin: auto;\n    }\n    // width: 50;\n    // height: 50px;\n    // border-radius: 25px;\n    // background-color: #39b54a;\n    // padding: 0 20px;\n\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    margin-top: 0px;\n}\n\n.contact-icons i {\n    font-size: 20px;\n    margin-right: 10px;\n    z-index: 10;\n}\n\n#facebook:hover {\n    color: #116466;\n}\n#twitter:hover {\n    color: #116466;\n}\n\n#linkedin:hover {\n    color: #116466;\n}\n\n#github:hover {\n    color: #116466;\n}\n\n#email:hover {\n    color: #116466;\n}\n\n@media (max-width: 1200px) {\n    .wrap-contact {\n        width: 440px;\n    }\n\n    .background {\n        width: calc(100% - 440px);\n    }\n}\n\n@media (max-width: 425px) {\n    .contact-icons {\n        left: 61%;\n        margin-top: 150px;\n    }\n}\n\n// @media (max-width: 768px) {\n//     .wrap-contact {\n//         width: 100%;\n//     }\n\n//     .background {\n//         display: none;\n//     }\n\n//     .contact-icons {\n//         position: relative;\n//         background-color: transparent;\n//         // margin-top: 100px;\n//         // margin-left: 50px;\n//         display: none;\n//         z-index: 10;\n//     }\n// }\n\n.nohighlight {\n    text-decoration: none;\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
